// Shared constants for the guest detail tab components.
// Extracted from GuestDetail.jsx during the Feb 2026 refactor.

// Human-friendly labels for show_suggestion dict keys returned by the AI chat
// endpoints. Used by both ShowPrepTab (Show Prep assistant) and PromoTab (Promo
// assistant) — they render `{SHOW_FIELD_LABELS[k] || k}` so unknown keys still
// display as the raw key.
export const SHOW_FIELD_LABELS = {
  audience: "Who is your audience?",
  viewer_takeaway: "What viewers get from every episode",
  host_bio: "Host bio",
  voice_tone: "Voice / tone words",
  never_words: "Words and phrases to never use",
  default_cta: "Default call to action",
  allow_emojis: "Allow emojis",
};
